// @flow

export default function createPassword(): string {
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const special = '!@#$%^&*()_+-=[]{}|;:,.<>?';
  const allChars = lowercase + uppercase + numbers + special;

  // Ensure we have at least one of each required character type
  let password = '';
  password += lowercase[Math.floor(Math.random() * lowercase.length)]; // one lowercase
  password += uppercase[Math.floor(Math.random() * uppercase.length)]; // one uppercase
  password += numbers[Math.floor(Math.random() * numbers.length)]; // one number
  password += special[Math.floor(Math.random() * special.length)]; // one special

  // Fill the rest with random characters to reach 10 characters total
  for (let i = 4; i < 10; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  // Shuffle the password to make it more random
  return password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('');
}
